import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';

import LocationSelectModal from './modal/LocationSelectModal';
import InfoSaveSuccessModal from './modal/InfoSaveSuccessModal';
import InfoPublishSuccessModal from './modal/InfoPublishSuccessModal';
import UploadComponent from './UploadComponent';
import getUserInfo from "../common/util/getUserInfo";
import setInputError from "../common/util/setInputError";
import restrictInputNumber from "../common/util/restrictInputNumber";
import showAlert from '../common/util/showAlert';
import CaptchaComponent from './CaptchaComponent';

export default class UserSubmitType1Component extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.wrapData = this.attrs.wrapData;
    this.wrapOriginalData = this.attrs.wrapData;
    this.selectedType = this.wrapData.selectedType;
    this.targetData = this.wrapData.targetData;
    this.viewType = this.wrapData.viewType || "normal";
    this.uploadingFile = false;
    this.editMode = this.attrs.editMode || false;
    this.resetData = false;
    this.currentUserData = app.session.user;
    this.isOwner = false;
    const from = this.wrapData.from;
    this.infoUserID = null;
    this.currentUserID = null;
    this.u2diCaptcha = Stream("");
    this.gr_es_nzjd = false;
    this.gr_ys = false;
    this.jjType = 0;
    this.jjTypeValue = null;
    this.infoJjType = null;

    if(this.currentUserData){
      this.currentUserID = this.currentUserData.id();
    }

    if(this.targetData){
      let u2diBaseData = this.targetData;

      if(this.targetData.data.type==="u2diInfoQueries"){
        u2diBaseData = this.targetData.u2diBaseData();
      }else{
        u2diBaseData = this.targetData;
      }

      const infoStatus = u2diBaseData.status();
      this.infoUserID = u2diBaseData.userID();
      this.jjType = this.infoJjType = u2diBaseData.jjType();
      
      if(infoStatus){
        this.viewType = "read";
      }
    }

    if(this.currentUserData){
      let u2diUserInfo = getUserInfo(from==="publish"?this.currentUserData.id():this.infoUserID);

      if(u2diUserInfo){
        this.jjType = this.infoJjType===0?0:u2diUserInfo.jjType();
        this.jjTypeValue = u2diUserInfo.jjTypeValue();
      }
    }

    if(this.wrapData.initType==="add"){
      this.reports = 0;
      this.option_zcqs = Stream("gs");
      this.option_lzxz = Stream("es");
      this.option_lzxz_checked = Stream(0);
      this.option_zclb = Stream("zzyd");
      this.option_zcwz = Stream({position:null,name:null,city:null});
      this.option_tdmj = Stream("");
      this.option_jzmj = Stream("");
      this.option_jzmj_disabled = Stream(true);
      this.option_synx = Stream("");
      this.option_zcdb = Stream(0);
      this.option_zpzl = Stream([]);
      this.option_ystd = Stream("");
      this.option_ghtj = Stream(1);
      this.option_wjzl = Stream([]);
      this.option_ydmj = Stream("");
      this.option_rjl = Stream("");
      this.option_ldl = Stream("");
      this.option_jzmd = Stream("");
      this.option_jzxg = Stream("");
      this.option_jzxg_disabled = Stream(false);
      // this.option_ysx = Stream(0);
      // this.option_cjjg = Stream("");
      this.option_crxs = Stream("cr");
      this.option_ssyq = Stream("");
      this.option_ssyq_checked = Stream("");
      this.option_ysdj = Stream("");
      this.option_yqjg = Stream("");
      this.option_jjbl = Stream(this.jjType===1?this.jjTypeValue:"");
      this.extra_wtxy = Stream([]);
      this.option_zsyq = Stream("");
      this.option_lxxx = Stream(1);
      this.userSigned = 0;

      if(this.currentUserData){
        let userInfo = getUserInfo(this.currentUserData.id());
        let option_lxdh_checked = userInfo.lxdh()===userInfo.lxdh_wx();

        this.userSigned = userInfo.userSigned();
        this.userKey = userInfo.userKey();
        this.option_bmqy = Stream(userInfo.bmqy());
        this.option_zjgw = Stream(userInfo.zjgw());
        this.option_zsxm = Stream(userInfo.zsxm());
        this.option_zsxm_title = Stream(userInfo.zsxm_title());
        this.option_lxdh = Stream(CryptoJSAesJson.decrypt(userInfo.lxdh(), this.userKey));
        this.option_lxdh_checked = Stream(option_lxdh_checked?0:1);
        this.option_lxdh_wx_value = Stream(CryptoJSAesJson.decrypt(userInfo.lxdh_wx(), this.userKey));;
        this.option_lxdh_wx_value_disabled = Stream(option_lxdh_checked);
      }else{
        this.option_bmqy = Stream("");
        this.option_zjgw = Stream("");
        this.option_zsxm = Stream("");
        this.option_zsxm_title = Stream(0);
        this.option_lxdh = Stream("");
        this.option_lxdh_checked = Stream(0);
        this.option_lxdh_wx_value = Stream("");
        this.option_lxdh_wx_value_disabled = Stream(true);
      }
    }else if(this.wrapData.initType==="resume"){
      this.reports = this.wrapData.reports;
      this.option_zcqs = Stream(this.wrapData.option_zcqs());
      this.option_lzxz = Stream(this.wrapData.option_lzxz());
      this.option_lzxz_checked = Stream(this.wrapData.option_lzxz_checked());
      this.option_zclb = Stream(this.wrapData.option_zclb());
      this.option_zcwz = Stream(this.wrapData.option_zcwz());
      this.option_tdmj = Stream(this.wrapData.option_tdmj());
      this.option_jzmj = Stream(this.wrapData.option_jzmj());
      this.option_jzmj_disabled = Stream(this.wrapData.option_jzmj_disabled());
      this.option_synx = Stream(this.wrapData.option_synx());
      this.option_zcdb = Stream(this.wrapData.option_zcdb());
      this.option_zpzl = Stream(this.wrapData.option_zpzl());
      this.option_ystd = Stream(this.wrapData.option_ystd());
      this.option_ghtj = Stream(this.wrapData.option_ghtj());
      this.option_wjzl = Stream(this.wrapData.option_wjzl());
      this.option_ydmj = Stream(this.wrapData.option_ydmj());
      this.option_rjl = Stream(this.wrapData.option_rjl());
      this.option_ldl = Stream(this.wrapData.option_ldl());
      this.option_jzmd = Stream(this.wrapData.option_jzmd());
      this.option_jzxg = Stream(this.wrapData.option_jzxg());
      this.option_jzxg_disabled = Stream(this.wrapData.option_jzxg_disabled());
      // this.option_ysx = Stream(this.wrapData.option_ysx());
      // this.option_cjjg = Stream(this.wrapData.option_cjjg());
      this.option_crxs = Stream(this.wrapData.option_crxs());
      this.option_ssyq = Stream(this.wrapData.option_ssyq());
      this.option_ssyq_checked = Stream(this.wrapData.option_ssyq_checked());
      this.option_ysdj = Stream(this.wrapData.option_ysdj());
      this.option_yqjg = Stream(this.wrapData.option_yqjg());
      this.option_jjbl = Stream(this.wrapData.option_jjbl());
      this.extra_wtxy = Stream(from==="publish"?this.wrapData.extra_wtxy():[]);
      this.option_zsyq = Stream(this.wrapData.option_zsyq());
      this.option_lxxx = Stream(this.wrapData.option_lxxx());
      this.option_bmqy = Stream(this.wrapData.option_bmqy());
      this.option_zjgw = Stream(this.wrapData.option_zjgw());
      this.option_zsxm = Stream(this.wrapData.option_zsxm());
      this.option_zsxm_title = Stream(this.wrapData.option_zsxm_title());
      this.option_lxdh = Stream(this.wrapData.option_lxdh());
      this.option_lxdh_checked = Stream(this.wrapData.option_lxdh_checked());
      this.option_lxdh_wx_value = Stream(this.wrapData.option_lxdh_wx_value());
      this.option_lxdh_wx_value_disabled = Stream(this.wrapData.option_lxdh_wx_value_disabled()); 
    }
  }

  onupdate(){
    if(this.editMode!==this.attrs.editMode){
      this.editMode = this.attrs.editMode;
      m.redraw();
    }

    if(this.resetData===true){
      this.resetData = false;
      
      this.option_zcqs = Stream(this.wrapOriginalData.option_zcqs());
      this.option_lzxz = Stream(this.wrapOriginalData.option_lzxz());
      this.option_lzxz_checked = Stream(this.wrapOriginalData.option_lzxz_checked());
      this.option_zclb = Stream(this.wrapOriginalData.option_zclb());
      this.option_zcwz = Stream(this.wrapOriginalData.option_zcwz());
      this.option_tdmj = Stream(this.wrapOriginalData.option_tdmj());
      this.option_jzmj = Stream(this.wrapOriginalData.option_jzmj());
      this.option_jzmj_disabled = Stream(this.wrapOriginalData.option_jzmj_disabled());
      this.option_synx = Stream(this.wrapOriginalData.option_synx());
      this.option_zcdb = Stream(this.wrapOriginalData.option_zcdb());
      this.option_zpzl = Stream(this.wrapOriginalData.option_zpzl());
      this.option_ystd = Stream(this.wrapOriginalData.option_ystd());
      this.option_ghtj = Stream(this.wrapOriginalData.option_ghtj());
      this.option_wjzl = Stream(this.wrapOriginalData.option_wjzl());
      this.option_ydmj = Stream(this.wrapOriginalData.option_ydmj());
      this.option_rjl = Stream(this.wrapOriginalData.option_rjl());
      this.option_ldl = Stream(this.wrapOriginalData.option_ldl());
      this.option_jzmd = Stream(this.wrapOriginalData.option_jzmd());
      this.option_jzxg = Stream(this.wrapOriginalData.option_jzxg());
      this.option_jzxg_disabled = Stream(this.wrapOriginalData.option_jzxg_disabled());
      // this.option_ysx = Stream(this.wrapOriginalData.option_ysx());
      // this.option_cjjg = Stream(this.wrapOriginalData.option_cjjg());
      this.option_crxs = Stream(this.wrapOriginalData.option_crxs());
      this.option_ssyq = Stream(this.wrapOriginalData.option_ssyq());
      this.option_ssyq_checked = Stream(this.wrapOriginalData.option_ssyq_checked());
      this.option_ysdj = Stream(this.wrapOriginalData.option_ysdj());
      this.option_yqjg = Stream(this.wrapOriginalData.option_yqjg());
      this.option_jjbl = Stream(this.wrapOriginalData.option_jjbl());
      // this.extra_wtxy = Stream(this.wrapOriginalData.extra_wtxy());
      this.option_zsyq = Stream(this.wrapOriginalData.option_zsyq());
      this.option_lxxx = Stream(this.wrapOriginalData.option_lxxx());
      this.option_bmqy = Stream(this.wrapOriginalData.option_bmqy());
      this.option_zjgw = Stream(this.wrapOriginalData.option_zjgw());
      this.option_zsxm = Stream(this.wrapOriginalData.option_zsxm());
      this.option_zsxm_title = Stream(this.wrapOriginalData.option_zsxm_title());
      this.option_lxdh = Stream(this.wrapOriginalData.option_lxdh());
      this.option_lxdh_checked = Stream(this.wrapOriginalData.option_lxdh_checked());
      this.option_lxdh_wx_value = Stream(this.wrapOriginalData.option_lxdh_wx_value());
      this.option_lxdh_wx_value_disabled = Stream(this.wrapOriginalData.option_lxdh_wx_value_disabled()); 
    }
  }
  
  onZCQSReady(){
    m.redraw();

    $("#u2di_zcqs_option").on('change', function() {
      setTimeout(function(){
        m.redraw();
      },100);
    });
  }

  onCategoryReady(){
    const _this = this;

    $('input[type=radio][name=option_ghtj]').on('change', function() {
      _this.option_ghtj(parseInt($(this).val()));
      m.redraw();
    });

    $("#jzxg").on('change', function() {
      _this.option_jzxg_disabled(this.checked);
      _this.option_jzxg("");
      m.redraw();
    });

    $('input[type=radio][name=option_lzxz_checked]').on('change', function() {
      let value = parseInt($(this).val());
      _this.option_lzxz_checked(value);
      _this.option_jzmj_disabled(value===0);
      _this.option_jzmj("");
      m.redraw();
    });

    $('input[type=radio][name=option_lxdh_checked]').on('change', function() {
      let value = parseInt($(this).val());
      _this.option_lxdh_checked(value);
      _this.option_lxdh_wx_value_disabled(value===0);
      _this.option_lxdh_wx_value(value===1?"":_this.option_lxdh());
      m.redraw();
    });

    $('#option_jjbl').on('input', function(e) {
       _this.option_jjbl(restrictInputNumber(e.target))
    });
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    const _this = this;

    $('input[type=radio][name=option_lxxx]').on('change', function() {
      let value = parseInt($(this).val());
      _this.option_lxxx(value);

      if(value===0){
        _this.option_zcqs("gr");
      }else if(value===1){
        _this.option_zcqs("gs");
      }
      
      m.redraw();
    });

    $('input[type=radio][name=option_zsxm]').on('change', function() {
      _this.option_zsxm_title(parseInt($(this).val()));
    });

    $('input[type=checkbox][name=option_ssyq_checked]').on('change', function() {
      let value = parseInt($(this).val());

      if(value!==_this.option_ssyq_checked()){
        $('input[type="checkbox"][name=option_ssyq_checked]').not(this).prop('checked', false);
        _this.option_ssyq_checked(value);
        _this.option_ssyq("");
      }else{
        _this.option_ssyq_checked("");
      }

      m.redraw();
    });

    // $("#option_ysx").change(function() {
    //   _this.option_ysx(this.checked===true?1:0);

    //   if(this.checked===true){
    //     _this.option_cjjg("");
    //   }

    //   m.redraw();
    // }); 
  }

  view() {
    const selectedType = this.selectedType = this.wrapData.selectedType;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const from = this.wrapData.from;
    let option_zcwz_name = "";
    let locationSelectable = true;

    if((this.currentUserID!==null && (u2diUserType9===true || this.currentUserID==this.infoUserID)) || from==="publish"){
      option_zcwz_name = this.option_zcwz().name;
    }else{
      if(this.currentUserID!==null){
        if(this.option_zcwz().province){
          option_zcwz_name = this.option_zcwz().province+this.option_zcwz().city;
          locationSelectable = false;
        }
      }
    }

    let crxsOptions = {};

    if(this.option_zcqs()!=="gy"){
      crxsOptions["cr"] = app.translator.trans('ziven-u2di.forum.option-crxs-cr');
    }

    if(selectedType==="jzwz"){
      crxsOptions["zz"] = app.translator.trans('ziven-u2di.forum.option-crxs-zz');
    }

    if(selectedType==="tdwz" && app.session.user && this.option_zcqs()==="gy"){
      crxsOptions["zs"] = app.translator.trans('ziven-u2di.forum.option-crxs-zs');
      this.option_crxs("zs");
    }

    const gr_es_nzjd = this.option_zcqs()==="gr" && this.option_lzxz()==="es" && this.option_zclb()==="nzjd";

    if(gr_es_nzjd===true){
      crxsOptions = {
        'zz': app.translator.trans('ziven-u2di.forum.option-crxs-zz')
      };

      this.option_crxs("zz");
      this.gr_es_nzjd = true;
    }else{
      if(this.gr_es_nzjd===true){
        this.gr_es_nzjd = false;
        this.option_crxs("cr");
        m.redraw();
      }
    }

    if(crxsOptions[this.option_crxs()]===undefined){
      this.option_crxs("cr");
      m.redraw();
    }

    let zcqsOptions = {
      'gr': app.translator.trans('ziven-u2di.forum.option-zcqs-gr'),
      'gs': app.translator.trans('ziven-u2di.forum.option-zcqs-gs'),
    };

    if(app.session.user && selectedType==="tdwz"){ 
      zcqsOptions["gy"] = app.translator.trans('ziven-u2di.forum.option-zcqs-gy');
    }

    let lzxzOptions = {};

    if(this.option_zcqs()!=="gy"){
      lzxzOptions["es"] = app.translator.trans('ziven-u2di.forum.option-lzxz-es');
      this.option_lzxz("es");
    }

    if(app.session.user && this.option_zcqs()==="gy"){ 
      lzxzOptions["ys"] = app.translator.trans('ziven-u2di.forum.option-lzxz-ys');
      this.option_lzxz("ys");
    }

    if(zcqsOptions[this.option_zcqs()]===undefined){
      this.option_zcqs("gr");
    }

    let zclbOptions = {};

    if(selectedType==="jzwz"){ 
      zclbOptions["syjz"] = app.translator.trans('ziven-u2di.forum.option-zclb-syjz');
      zclbOptions["gyjz"] = app.translator.trans('ziven-u2di.forum.option-zclb-gyjz');
      zclbOptions["wlck"] = app.translator.trans('ziven-u2di.forum.option-zclb-wlck');

      if(app.forum.attribute('u2diUserType9')===true || app.session.user===null){
        zclbOptions["nzjd"] = app.translator.trans('ziven-u2di.forum.option-zclb-nzjd');
      }

      if(zclbOptions[this.option_zclb()]===undefined){
        this.option_zclb("syjz");
        m.redraw();
      }
    }else if(selectedType==="tdwz"){ 
      zclbOptions["zzyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-zzyd');
      zclbOptions["syyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-syyd');
      zclbOptions["gyyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-gyyd');
      zclbOptions["wlcc"] = app.translator.trans('ziven-u2di.forum.option-zclb-wlcc');

      if(zclbOptions[this.option_zclb()]===undefined){
        this.option_zclb("zzyd");
        m.redraw();
      }
    }

    let zcdbOptions = {};
    zcdbOptions["0"] = app.translator.trans('ziven-u2di.forum.option-zcdb-0');
    zcdbOptions["1"] = app.translator.trans('ziven-u2di.forum.option-zcdb-1');

    if(u2diUserType0===true || u2diUserType9===true){
      zcdbOptions["2"] = app.translator.trans('ziven-u2di.forum.option-zcdb-2');
    }

    if(selectedType==="jzwz"){
      zcdbOptions["3"] = app.translator.trans('ziven-u2di.forum.option-zcdb-3');
    }

    return (
      <div id="u2diUserSubmitType1Content" className="u2diUserSubmitType1Container">
        <div className="u2diUserSubmitCategoryName">{app.translator.trans('ziven-u2di.forum.user-submission-category-zcxx')}</div>

        <div className="u2diUserSubmitCategoryItems">
          <div className="u2diUserSubmitCategoryItemName">
            {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zcqs')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions" oncreate={this.onZCQSReady.bind(this)}>
            <Select id="u2di_zcqs_option" className="u2diDataSelectList" value={this.option_zcqs()}
              disabled={this.viewType==="read" || this.editMode===false}
              options={zcqsOptions}
              onchange={(e) => {
                this.option_zcqs(e);

                if(e==="gr"){
                  this.option_lxxx(0);
                }else if(e==="gs"){
                  this.option_lxxx(1);
                }
                m.redraw();
              }}
            />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems">
          <div className="u2diUserSubmitCategoryItemName">
            {app.translator.trans('ziven-u2di.forum.user-submission-category-item-lzxz')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <Select className="u2diDataSelectList" value={this.option_lzxz()}
              disabled={this.viewType==="read" || this.editMode===false}
              options={lzxzOptions}
              onchange={(e) => {
                this.option_lzxz(e); 
                m.redraw();
              }}
            />
          </div>
        </div>

        <div className="u2diUserSubmitCategoryItems">
          <div className="u2diUserSubmitCategoryItemName">
            {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zclb')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <Select className="u2diDataSelectList" value={this.option_zclb()}
              disabled={this.viewType==="read" || this.editMode===false}
              options={zclbOptions}
              onchange={(e) => {
                this.option_zclb(e);
                m.redraw();
              }}
            />
          </div>
        </div>

        <div style="align-items: flex-start;" className="u2diUserSubmitCategoryItems">
          <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItemName">
            {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zcwz')}
          </div>
          <div style="padding-top: 5px;padding-bottom: 10px;" className="u2diUserSubmitCategoryItemOptions">
            {!option_zcwz_name && (
              <div id="option_zcwz" className="u2diLink" onclick={(e) => { if(locationSelectable){this.selectMapPosition();} }}>
                {app.translator.trans('ziven-u2di.forum.option-zcwz-select-location')}
              </div>  
            )}

            {option_zcwz_name && (
              <div style="display: flex;">
                <div style="max-width: 400px;" className="u2diLinkType2 u2diEllipsisArea" onclick={(e) => { if(locationSelectable){this.selectMapPosition();} }}>
                  {option_zcwz_name}
                </div>
                &nbsp;<i style="margin-top: 3px;" class="fas fa-th-large-marker-alt"></i>
              </div>
            )}
          </div>
        </div>

        {selectedType==="tdwz" && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-tdmj')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <input id="option_tdmj" style="width:100px" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_tdmj} />
              <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-mu')}</span>

              <span>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem3">
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="lzxz_value0" type="radio" name="option_lzxz_checked" value="0" checked={this.option_lzxz_checked()===0?"checked":""} /><label style="margin-left: 5px;" for="lzxz_value0">{app.translator.trans('ziven-u2di.forum.option-lzxz-value-0')}</label>
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem2">
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="lzxz_value1" type="radio" name="option_lzxz_checked" value="1" checked={this.option_lzxz_checked()===1?"checked":""} /><label style="margin-left: 5px;" for="lzxz_value1">{app.translator.trans('ziven-u2di.forum.option-lzxz-value-1')}</label>
                  <input disabled={this.viewType==="read" || this.editMode===false || this.option_jzmj_disabled()} id="option_jzmj" required style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_jzmj} />
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-squre-meter')}</span>
                </div>
              </span>

            </div>
          </div>
        )}

        {selectedType==="jzwz" && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-jzmj')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <input id="option_jzmj" style="width:100px" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_jzmj} />
              <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-squre-meter')}</span>
            
              {gr_es_nzjd===false && (
                <span>
                  <div className="u2diOptionsAdjustItem u2diOptionsMarginItem4">
                    <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" type="radio" value="1" checked /><label style="margin-left: 5px;">{app.translator.trans('ziven-u2di.forum.user-submission-category-item-tdmj')}</label>
                    <input id="option_tdmj" disabled={this.viewType==="read" || this.editMode===false} required style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_tdmj} />
                    <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-mu')}</span>
                  </div>
                </span>
              )}
            </div>
          </div>
        )}

        <div className="u2diUserSubmitCategoryItems">
          <div className="u2diUserSubmitCategoryItemName">
            {app.translator.trans(gr_es_nzjd===true?'ziven-u2di.forum.user-submission-category-item-crnx':'ziven-u2di.forum.user-submission-category-item-synx')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <input id="option_synx" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="1" min="1" bidi={this.option_synx} />
            <span className="u2diUserSubmitCategoryItemUnit">
              {app.translator.trans('ziven-u2di.lib.unit-year')}
              {this.option_zcqs()==="gy"?"":(gr_es_nzjd===true?app.translator.trans('ziven-u2di.forum.user-submission-category-item-crnx-hint'):app.translator.trans('ziven-u2di.forum.user-submission-category-item-synx-hint'))}
            </span>
          </div>
        </div>

        {gr_es_nzjd===false && this.option_zcqs()!=="gy" && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zcdb')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions u2diUserSubmitCategoryItemOptionsPadding">
              <Select className="u2diDataSelectList" value={this.option_zcdb()}
                disabled={this.viewType==="read" || this.editMode===false}
                options={zcdbOptions}
                onchange={(e) => { this.option_zcdb(e); }}
              />
            </div>
          </div>
        )}
          
        {(from==="publish" || u2diUserType9===true || (from!=="distribute" && this.currentUserID!==null && this.infoUserID==this.currentUserID)) && this.option_zcqs()!=="gy" && (
          <div style="padding-top: 5px;padding-bottom: 15px;align-items: flex-start;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans(gr_es_nzjd===true?'ziven-u2di.forum.user-submission-category-item-xczp':'ziven-u2di.forum.user-submission-category-item-zpzl')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <UploadComponent uploadLimit="6" viewType={this.editMode===true?"edit":"read"} uploadType="option_zpzl" uploadTarget={this.option_zpzl} uploadCallback={function(result,option_target){
                  this.option_zpzl = option_target;
              }} />
            </div>
          </div>
        )}

        {this.option_zcqs()!=="gy" && (
          <div style="align-items: flex-start;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-ystd')}
            </div>
            <div style="width: 65%" className="u2diUserSubmitCategoryItemOptions">
              <textarea id="option_ystd" disabled={this.viewType==="read" || this.editMode===false} style="height: 80px;" maxlength="1000" required className="FormControl" bidi={this.option_ystd} />
            </div>
          </div>
        )}

        {selectedType==="tdwz" && (
          <div style={(window.selectedCategory==="fx" && u2diUserType9===false)?"display:none":""} oncreate={this.onCategoryReady.bind(this)}>
            <div className="u2diUserSubmitCategoryName">{app.translator.trans('ziven-u2di.forum.user-submission-category-ghtj')}</div>

            <div style="padding-bottom: 20px;padding-top: 10px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemOptions">
                <input disabled={this.viewType==="read" || this.editMode===false} id="ghtj1" type="radio" name="option_ghtj" value="1" checked={this.option_ghtj()==1?"checked":""} /><label style="margin-left: 5px;" for="ghtj1">{app.translator.trans('ziven-u2di.forum.option-ghtj-1')}</label>
                <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="ghtj0" type="radio" name="option_ghtj" value="0" checked={this.option_ghtj()==0?"checked":""} /><label style="margin-left: 5px;" for="ghtj0">{app.translator.trans('ziven-u2di.forum.option-ghtj-0')}</label>
                <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="ghtj2" type="radio" name="option_ghtj" value="2" checked={this.option_ghtj()==2?"checked":""} /><label style="margin-left: 5px;" for="ghtj2">{app.translator.trans('ziven-u2di.forum.option-ghtj-2')}</label>
              </div>
            </div>

            {this.option_ghtj()==0 && (
              <div>
                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-ydmj')}
                  </div>
                  <div className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_ydmj" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_ydmj} />
                    <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-squre-meter')}</span>
                  </div>
                </div>

                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-rjl')}
                  </div>
                  <div className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_rjl" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_rjl} />
                  </div>
                </div>

                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-ldl')}
                    <span style="margin-left:33px">≥</span>
                  </div>
                  <div className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_ldl" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_ldl} />
                    <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-percentage')}</span>
                  </div>
                </div>

                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-jzmd')}
                    <span style="margin-left:20px">≤</span>
                  </div>
                  <div className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_jzmd" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_jzmd} />
                    <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-percentage')}</span>
                  </div>
                </div>

                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-jzxg')}
                  </div>
                  <div className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_jzxg" disabled={this.option_jzxg_disabled() || this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0" bidi={this.option_jzxg} />
                    <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-meter')}</span>
                    <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="jzxg" type="checkbox" value="0" checked={this.option_jzxg_disabled()===true?"checked":""} /><label style="margin-left: 5px;" for="jzxg">{app.translator.trans('ziven-u2di.forum.option-jzxg-0')}</label>
                  </div>
                </div>
              </div>
            )}

            {this.option_ghtj()==1 && (
              <div>
                <div style="align-items: flex-start;" className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-wjzl')}
                  </div>

                  <div className="u2diUserSubmitCategoryItemOptions">
                    <UploadComponent uploadLimit="3" viewType={this.editMode===true?"edit":"read"} uploadType="option_wjzl" uploadTarget={this.option_wjzl} uploadCallback={function(result,option_target){
                        this.option_wjzl = option_target;
                    }} />
                  </div>
                </div>
              </div>
            )}

          </div>
        )}

        <div className="u2diUserSubmitCategoryName">{app.translator.trans('ziven-u2di.forum.user-submission-category-jjxx')}</div>

        <div className="u2diUserSubmitCategoryItems">
          <div className="u2diUserSubmitCategoryItemName">
            {app.translator.trans('ziven-u2di.forum.user-submission-category-item-crxs')}
          </div>
          <div className="u2diUserSubmitCategoryItemOptions">
            <Select className="u2diDataSelectList" value={this.option_crxs()}
              disabled={this.viewType==="read" || this.editMode===false}
              options={crxsOptions}
              onchange={(e) => {
                this.option_crxs(e);
                m.redraw();
              }}
            />
          </div>
        </div>

        {this.selectedType==="tdwz" && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-ssyq')}
            </div>
            <div className="u2diUserSubmitCategoryItemOptions">
              <input id="option_ssyq" disabled={this.viewType==="read" || this.editMode===false || this.option_ssyq_checked()!==""} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_ssyq} />
              <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</span>

              <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="ssyq1" type="checkbox" name="option_ssyq_checked" value="0" checked={this.option_ssyq_checked()===0?"checked":""}  /><label style="margin-left: 5px;" for="ssyq1">{app.translator.trans('ziven-u2di.forum.option-ssyq-1')}</label>
                <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="ssyq2" type="checkbox" name="option_ssyq_checked" value="1" checked={this.option_ssyq_checked()===1?"checked":""} /><label style="margin-left: 5px;" for="ssyq2">{app.translator.trans('ziven-u2di.forum.option-ssyq-2')}</label>
              </div>
            </div>
          </div>
        )}

        {(this.option_crxs()==="zz" || this.option_crxs()==="cr" || this.option_zcqs()==="gy") && (
          <div>
            {this.option_crxs()!=="zz" && this.option_zcqs()!=="gy" && selectedType!=="jzwz" && (
              <div className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-ysdj')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <input id="option_ysdj" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_ysdj} />
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</span>
                  </div>
              </div>
            )}

            <div className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-yqjg')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <input id="option_yqjg" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_yqjg} />
                
                {this.selectedType==="tdwz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</span>
                )}

                {this.selectedType==="jzwz" && this.option_crxs()==="zz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-year')}</span>
                )}

                {this.selectedType==="jzwz" && this.option_crxs()!=="zz" && (
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-squre-meter')}</span>
                )}
                </div>
            </div>

            <div oncreate={this.onCategoryReady.bind(this)} className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-jjbl')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input data-decimal="2" id="option_jjbl" disabled={this.viewType==="read" || this.editMode===false || this.jjType===1} required className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.01" min="3" bidi={this.option_jjbl} />
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-percentage')}</span>
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <span className="u2diUserSubmitCategoryItemHelp">
                    {app.translator.trans(this.jjType===0?'ziven-u2di.forum.user-submission-category-item-jjbl-help':'ziven-u2di.forum.user-submission-category-item-jjtype-help')}
                  </span>
                </div>
              </div>
            </div>

            {this.option_jjbl()!=="" && this.option_jjbl()<3 && u2diUserType9===false && this.jjType===0 && (
              <div style={((window.selectedCategory==="fx" || window.selectedCategory==="td") && u2diUserType9===false)?"display:none":""} className="u2diUserSubmitCategoryItems ">
                <div className="u2diUserSubmitCategoryItemName">
                </div>
                <div className="u2diUserSubmitCategoryItemOptions u2diInputError">
                  居间比例数值不能小于3
                </div>
              </div>
            )}

            {from==="publish" && u2diUserType0===true && this.option_zcqs()!=="gy" && u2diUserType9===true && (
              <div>
                <div style={"align-items: flex-start;"+(this.editMode===false && this.extra_wtxy().length===0?"display:block":"")} className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-wtxy')}
                  </div>

                  <div className="u2diUserSubmitCategoryItemOptions">
                    <UploadComponent viewType={this.editMode===true?"edit":"read"} uploadType="extra_wtxy" uploadTarget={this.extra_wtxy} uploadCallback={function(result,option_target){
                        
                    }} />
                  </div>
                </div>
              </div>
            )}

          </div>
        )}

        {this.option_crxs()==="zs" && (
          <div style="align-items: flex-start;" className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zsyq')}
            </div>
            <div style="width: 65%" className="u2diUserSubmitCategoryItemOptions">
              <textarea disabled={this.viewType==="read" || this.editMode===false} style="height: 80px;" maxlength="1000" required className="FormControl" bidi={this.option_zsyq} />
            </div>
          </div>
        )}

        {from==="publish" && u2diUserType0===true && this.option_zcqs()==="gy" && u2diUserType9===true && (
          <div>
            <div style={"align-items: flex-start;"+(this.editMode===false && this.extra_wtxy().length===0?"display:block":"")} className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-wtxy')}
              </div>

              <div className="u2diUserSubmitCategoryItemOptions">
                <UploadComponent viewType={this.editMode===true?"edit":"read"} uploadType="extra_wtxy" uploadTarget={this.extra_wtxy} uploadCallback={function(result,option_target){
                    
                }} />
              </div>
            </div>
          </div>
        )}

        {(u2diUserType9===true || this.currentUserData===null) && (
          <div>
            <div className="u2diUserSubmitCategoryName">{app.translator.trans('ziven-u2di.forum.user-submission-category-lxxx')}</div>
            
            <div style="display:none;padding-bottom: 20px;padding-top: 10px;" className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemOptions">
                <input disabled={this.viewType==="read" || this.editMode===false} id="lxxx0" type="radio" name="option_lxxx" value="0" checked={this.option_lxxx()==0?"checked":""} /><label style="margin-left: 5px;" for="lxxx0">{app.translator.trans('ziven-u2di.forum.option-lxxx-0')}</label>
                <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="lxxx1" type="radio" name="option_lxxx" value="1" checked={this.option_lxxx()==1?"checked":""} /><label style="margin-left: 5px;" for="lxxx1">{app.translator.trans('ziven-u2di.forum.option-lxxx-1')}</label>
              </div>
            </div>

            {this.option_lxxx()=="1" && (
              <div>
                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-bmqy')}
                  </div>
                  <div style="width: 65%" className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_bmqy" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInputFullWidth" type="text" bidi={this.option_bmqy} />
                  </div>
                </div>

                <div className="u2diUserSubmitCategoryItems">
                  <div className="u2diUserSubmitCategoryItemName">
                    {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zjgw')}
                  </div>
                  <div style="width: 65%" className="u2diUserSubmitCategoryItemOptions">
                    <input id="option_zjgw" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInputFullWidth" type="text" bidi={this.option_zjgw} />
                  </div>
                </div>
              </div>
            )}

            <div className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zsxm')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_zsxm" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.option_zsxm} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title0" type="radio" name="option_zsxm" value="0" checked={this.option_zsxm_title()==0?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title0">{app.translator.trans('ziven-u2di.forum.option-zsxm-0')}</label>
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="zsxm_title1" type="radio" name="option_zsxm" value="1" checked={this.option_zsxm_title()==1?"checked":""} /><label style="margin-left: 5px;" for="zsxm_title1">{app.translator.trans('ziven-u2di.forum.option-zsxm-1')}</label>
                </div>
              </div>
            </div>

            {this.option_zsxm()!=="" && (this.option_zsxm().length<2 || this.option_zsxm().length>4) && (
              <div className="u2diUserSubmitCategoryItems ">
                <div className="u2diUserSubmitCategoryItemName">
                </div>
                <div style="color:var(--alert-error-bg)" className="u2diUserSubmitCategoryItemOptions">
                  真实姓名长度需要在2-4个字之间
                </div>
              </div>
            )}

            <div oncreate={this.onCategoryReady.bind(this)} className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemName">
                {app.translator.trans('ziven-u2di.forum.user-submission-category-item-lxdh')}
              </div>
              <div className="u2diUserSubmitCategoryItemOptions">
                <div className="u2diOptionsAdjustItem">
                  <input id="option_lxdh" disabled={this.viewType==="read" || this.editMode===false} required className="FormControl u2diUserSubmitCategoryItemInput" type="text" maxlength="11" bidi={this.option_lxdh} />
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1">
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx0" type="radio" name="option_lxdh_checked" value="0" checked={this.option_lxdh_checked()==0?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx0">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-0')}</label>
                </div>
                <div className="u2diOptionsAdjustItem u2diOptionsMarginItem1" style="padding-top: 0px;">
                  <input disabled={this.viewType==="read" || this.editMode===false} className="u2diUserSubmitCategoryItemRadio" id="lxdh_wx1" type="radio" name="option_lxdh_checked" value="1" checked={this.option_lxdh_checked()==1?"checked":""} /><label style="margin-left: 5px;" for="lxdh_wx1">{app.translator.trans('ziven-u2di.forum.option-lxdh-wx-1')}</label>
                  <input id="option_lxdh_wx_value" disabled={this.viewType==="read" || this.editMode===false || this.option_lxdh_wx_value_disabled()} required maxlength="11" style="margin-left: 15px;" className="FormControl u2diUserSubmitCategoryItemInput" type="text" bidi={this.option_lxdh_wx_value} />
                 </div>
              </div>
            </div>
          </div>
        )}

        {(this.viewType==="normal" || this.viewType==="edit") && this.editMode===true && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemName">
              {app.translator.trans('ziven-u2di.forum.captcha-validation')}
            </div>
            <div style="display: flex;" className="u2diUserSubmitCategoryItemOptions">
              <input id="u2diCaptcha" disabled={this.loading} required className="FormControl u2diUserSubmitCategoryItemInput" type="input" maxlength="4" bidi={this.u2diCaptcha} />
              <CaptchaComponent />
            </div>
          </div>
        )}
            
        {this.viewType==="read" && (
          <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  $(".Modal-close .Button").click();
                }
              },
              app.translator.trans('ziven-u2di.lib.close')
            )}
          </div>
        )}

        {(this.viewType==="normal" || this.viewType==="edit") && this.editMode===true && (
          <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"min-width:66px;",
                disabled: this.loading,
                type: 'submit',
                className: 'Button Button--primary',
                onclick: (e) => {
                  this.submitData(e)
                }
              },
              app.translator.trans(this.viewType==="normal"?'ziven-u2di.lib.publish':'ziven-u2di.lib.save')
            )}
            &nbsp;
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  if(from==="publish"){
                    $(".Modal-close .Button").click();
                  }else{
                    this.resetData = true;
                    $(window).trigger('u2diEditModeDisabled');
                  }
                }
              },
              app.translator.trans('ziven-u2di.lib.cancel')
            )}
          </div>
        )}

        {(this.viewType==="normal" || this.viewType==="edit") && this.editMode===false && (
          <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
            {Button.component({
                style:"min-width:66px;",
                className: 'Button U2DiButton--gray',
                disabled: this.loading,
                onclick: () => {
                  $(".Modal-close .Button").click();
                }
              },
              app.translator.trans('ziven-u2di.lib.close')
            )}
          </div>
        )}
      </div>
    );
  }

  getWrapData(){
    return {
      returnModal: "UserSubmitModal",
      targetData:this.targetData,
      selectedType:this.selectedType,
      viewType: this.viewType,
      from: this.wrapData.from,
      reports: this.reports,

      option_zcqs:this.option_zcqs,
      option_lzxz:this.option_lzxz,
      option_lzxz_checked:this.option_lzxz_checked,
      option_zclb:this.option_zclb,
      option_zcwz:this.option_zcwz,
      option_tdmj:this.option_tdmj,
      option_jzmj:this.option_jzmj,
      option_jzmj_disabled:this.option_jzmj_disabled,
      option_synx:this.option_synx,
      option_zcdb:this.option_zcdb,
      option_zpzl:this.option_zpzl,
      option_ystd:this.option_ystd,

      option_ghtj:this.option_ghtj,
      option_wjzl:this.option_wjzl,
      option_ydmj:this.option_ydmj,
      option_rjl:this.option_rjl,
      option_ldl:this.option_ldl,
      option_jzmd:this.option_jzmd,
      option_jzxg:this.option_jzxg,
      option_jzxg_disabled:this.option_jzxg_disabled,

      // option_ysx:this.option_ysx,
      // option_cjjg:this.option_cjjg,
      option_crxs:this.option_crxs,
      option_ssyq:this.option_ssyq,
      option_ssyq_checked:this.option_ssyq_checked,
      option_ysdj:this.option_ysdj,
      option_yqjg:this.option_yqjg,
      option_jjbl:this.option_jjbl,
      extra_wtxy:this.extra_wtxy,
      option_zsyq:this.option_zsyq,

      option_lxxx:this.option_lxxx,
      option_bmqy:this.option_bmqy,
      option_zjgw:this.option_zjgw,
      option_zsxm:this.option_zsxm,
      option_zsxm_title:this.option_zsxm_title,
      option_lxdh:this.option_lxdh,
      option_lxdh_checked:this.option_lxdh_checked,
      option_lxdh_wx_value:this.option_lxdh_wx_value,
      option_lxdh_wx_value_disabled:this.option_lxdh_wx_value_disabled,
    }
  }

  checkSubmitData(){
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const wrapData = this.getWrapData();
    let isValid = true;

    for(let index in wrapData){
      if(u2diUserType9===true){
        if(index==="option_bmqy" || index==="option_zjgw"){
          continue;
        }
      }

      if(typeof(wrapData[index])!=="function"){
        continue;
      }

      if((wrapData[index]()).length===0 && $("#"+index).length>0 && $("#"+index).prop('disabled')!==true){
        setInputError("#"+index,isValid);
        isValid = false;
      }
    }

    if($("#option_jjbl").length>0 && this.option_jjbl()<3 && u2diUserType9===false && this.jjType===0){
      setInputError("#option_jjbl",isValid);
      isValid = false;
    }

    if($("#option_zsxm").length>0 && (this.option_zsxm().length<2 || this.option_zsxm().length>4)){
      setInputError("#option_zsxm",isValid);
      isValid = false;
    }

    if(this.option_zcwz().position===null){
      setInputError("#option_zcwz",isValid);
      isValid = false;
    }

    return isValid;
  }

  selectMapPosition() {
    const wrapData = this.getWrapData();
    const editMode = this.editMode;
    app.modal.show(LocationSelectModal,{wrapData,editMode});
  }

  submitData(e) {
    e.preventDefault();

    if(this.checkSubmitData()===false){
      showAlert(app.translator.trans('ziven-u2di.forum.error-input-empty'));
      return;
    }

    let size = 0;
    this.loading = true;

    if(this.selectedType==="tdwz"){
      size = this.option_tdmj();
    }else if(this.selectedType==="jzwz"){
      size = this.option_jzmj();
    }
    
    const submitData = {
      u2diCaptcha:this.u2diCaptcha(),
      extra: {
        extra_wtxy:this.extra_wtxy(),
      },
      base:{
        position:this.option_zcwz(),
        price: this.option_yqjg(),
        size: size,
        category: this.selectedType,
        type:this.option_zclb()
      },
      details:{
        zcxx:JSON.stringify({
          option_zcqs:this.option_zcqs(),
          option_lzxz:this.option_lzxz(),
          option_lzxz_checked:this.option_lzxz_checked(),
          option_zclb:this.option_zclb(),
          option_zcwz:this.option_zcwz(),
          option_tdmj:this.option_tdmj(),
          option_jzmj:this.option_jzmj(),
          option_jzmj_disabled:this.option_jzmj_disabled(),
          option_synx:this.option_synx(),
          option_zcdb:this.option_zcdb(),
          option_zpzl:this.option_zpzl(),
          option_ystd:this.option_ystd(),
        }),
        ghtj:JSON.stringify({
          option_ghtj:this.option_ghtj(),
          option_wjzl:this.option_wjzl(),
          option_ydmj:this.option_ydmj(),
          option_rjl:this.option_rjl(),
          option_ldl:this.option_ldl(),
          option_jzmd:this.option_jzmd(),
          option_jzxg:this.option_jzxg(),
          option_jzxg_disabled:this.option_jzxg_disabled(),
        }),
        jjxx:JSON.stringify({
          // option_ysx:this.option_ysx(),
          // option_cjjg:this.option_cjjg(),
          option_crxs:this.option_crxs(),
          option_ssyq:this.option_ssyq(),
          option_ssyq_checked:this.option_ssyq_checked(),
          option_ysdj:this.option_ysdj(),
          option_yqjg:this.option_yqjg(),
          option_jjbl:this.option_jjbl(),
          option_zsyq:this.option_zsyq(),
        }),
        lxxx:JSON.stringify({
          option_lxxx:this.option_lxxx(),
          option_bmqy:this.option_bmqy(),
          option_zjgw:this.option_zjgw(),
          option_zsxm:this.option_zsxm(),
          option_zsxm_title:this.option_zsxm_title(),
          option_lxdh:this.option_lxdh(),
          option_lxdh_checked:this.option_lxdh_checked(),
          option_lxdh_wx_value:this.option_lxdh_wx_value(),
          option_lxdh_wx_value_disabled:this.option_lxdh_wx_value_disabled(),
        })
      }
    };

    if(this.wrapData.viewType==="edit"){
      let from = this.wrapData.from;
      let targetData = from==="info"?this.targetData:this.targetData.u2diBaseData();

      targetData.save(submitData)
      .then(() => {
            app.modal.show(InfoSaveSuccessModal);
        },
        (response) => {
          this.loading = false;
          $(".u2diCaptcheImage").click();
          m.redraw();
        }
      );
    }else if(this.wrapData.viewType==="normal"){
      app.store
        .createRecord("u2diInfoBase")
        .save(submitData)
        .then((returnData) => {
            app.modal.show(InfoPublishSuccessModal,{returnData});
            $(window).trigger('u2diInfoAdd');
          }
        )
        .catch((e) => {
          this.loading = false;
          $(".u2diCaptcheImage").click();
        });
    }

  }

}